/**
 * Settings > Policies pages render through Shopify's fixed policy template,
 * which no theme file can override (confirmed: templates/policy.liquid is
 * never invoked, even when present). This is the only place left to add the
 * eyebrow label and the kc-anchor-page-style sidebar nav that every other
 * long-form page on this theme gets from section markup. Loaded globally
 * (layout/theme.liquid); it no-ops immediately on every page that is not one
 * of these five.
 */
(function () {
  var EYEBROWS = [
    { match: /shipping/i, label: 'Shipping' },
    { match: /refund/i, label: 'Returns & shortages' },
    { match: /terms/i, label: 'Legal' },
    { match: /privacy/i, label: 'Privacy' },
    { match: /contact/i, label: 'Contact' },
  ];

  function eyebrowFor(headingText) {
    for (var i = 0; i < EYEBROWS.length; i++) {
      if (EYEBROWS[i].match.test(headingText)) return EYEBROWS[i].label;
    }
    return 'Policy';
  }

  function init() {
    var title = document.querySelector('.shopify-policy__title');
    var heading = title && title.querySelector('h1');
    var rte = document.querySelector('.shopify-policy__body .rte');
    if (!title || !heading || !rte) return;

    if (!title.querySelector('.kc-policy-eyebrow')) {
      var eyebrow = document.createElement('p');
      eyebrow.className = 'kc-policy-eyebrow';
      eyebrow.textContent = eyebrowFor(heading.textContent);
      title.insertBefore(eyebrow, heading);
    }

    var headings = Array.prototype.filter.call(rte.children, function (el) {
      return el.tagName === 'H2';
    });
    if (headings.length < 2) return;

    headings.forEach(function (h, index) {
      if (!h.id) h.id = 'policy-section-' + index;
    });

    var nav = document.createElement('nav');
    nav.className = 'kc-policy-nav';
    nav.setAttribute('aria-label', 'On this page');

    var navHeading = document.createElement('p');
    navHeading.className = 'kc-policy-nav__heading';
    navHeading.textContent = 'On this page';
    nav.appendChild(navHeading);

    var list = document.createElement('ul');
    list.className = 'kc-policy-nav__list';
    var links = headings.map(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'kc-policy-nav__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    nav.appendChild(list);

    var container = rte.closest('.shopify-policy__body');
    var grid = document.createElement('div');
    grid.className = 'kc-policy-grid';
    container.parentNode.insertBefore(grid, container);
    grid.appendChild(nav);
    grid.appendChild(container);

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries.filter(function (entry) {
          return entry.isIntersecting;
        });
        if (visible.length === 0) return;
        var activeId = visible[0].target.id;
        links.forEach(function (link) {
          if (link.getAttribute('href') === '#' + activeId) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );
    headings.forEach(function (h) {
      observer.observe(h);
    });
    links[0].setAttribute('aria-current', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
